import { createFeatureSelector } from '@ngrx/store';
import { checkUserExitFeatureKey } from '../reducers/sign-up.reducer';
import { appState } from 'src/app';

export const selectCheckUser = createFeatureSelector<appState>(checkUserExitFeatureKey);
